import { createClearType, createSetType } from '../actionHelpers';

export const SET_STORAGE_PRODUCT = createSetType('BUY_STORAGE_PRODUCT');
export const SET_BUY_STORAGE_TYPE = createSetType('BUY_STORAGE_TYPE');
export const SET_BUY_STORAGE_INPUT_VALUE = createSetType(
  'BUY_STORAGE_INPUT_VALUE',
);
export const CLEAR_BUY_STORAGE_STATE = createClearType('BUY_STORAGE_STATE');
